export default __webpack_public_path__ + "static/media/unpromoted.13f002c0.png";